import { render, staticRenderFns } from "./order-status-review.vue?vue&type=template&id=53bc8ff2&"
import script from "./order-status-review.vue?vue&type=script&lang=js&"
export * from "./order-status-review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53bc8ff2')) {
      api.createRecord('53bc8ff2', component.options)
    } else {
      api.reload('53bc8ff2', component.options)
    }
    module.hot.accept("./order-status-review.vue?vue&type=template&id=53bc8ff2&", function () {
      api.rerender('53bc8ff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/device-manage/order-status/order-status-review.vue"
export default component.exports